import { useContext } from "react";
import { Context } from "../../../utils/main-context/MainContext";

import { useParams } from "react-router-dom";

import "./card-hero.scss";

import projects from "../../../database/projects.json";

import CardImage1 from "../../../assets/images/maybach-shop/1.png";
import CardImage2 from "../../../assets/images/maybach-dash/1.png";
import CardImage3 from "../../../assets/images/gi-group/1.png";
import CardImage4 from "../../../assets/images/project-backend/1.png";

const CardHero = () => {
  const { workHeroActive } = useContext(Context);

  const params = useParams();

  const project = projects.projects.find((data) => data.id === params?.id);

  return (
    <section className={workHeroActive ? "card-hero active" : "card-hero"}>
      <div className="card-image">
        {params?.id === "1" && <img src={CardImage1} alt={project.name} />}
        {params?.id === "2" && <img src={CardImage2} alt={project.name} />}
        {params?.id === "3" && <img src={CardImage3} alt={project.name} />}
        {params?.id === "4" && <img src={CardImage4} alt={project.name} />}
        {/* {!params && <img src={DefaultImage} alt={project.name} />} */}
      </div>
      <div className="card-details">
        <h2 className="card-title">{project.name}</h2>
        <p className="card-about">{project.about}</p>
      </div>
    </section>
  );
};

export default CardHero;
